import React, { Component } from 'react'
import { Link } from 'react-router-dom';

class Sidebar extends Component {
  render() {
    return(
      <div className="site-sidebar">
        <div className="custom-scroll custom-scroll-light">
          <ul className="sidebar-menu">
            <li className="menu-title">Main</li>
            <li className={'with-sub ' + (window.location.pathname.startsWith('/pos') ? 'active' : '')}>
              <a href="/pos" className="waves-effect  waves-light">
                <span className="s-caret"><i className="fa fa-angle-down"></i></span>
                <span className="s-icon"><i className="ti-shopping-cart"></i></span>
                <span className="s-text">Point of Sale</span>
              </a>
            </li>
            <li className={'with-sub ' + (window.location.pathname.startsWith('/reports') ? 'active' : '')}>
              <a href="#reports" className="waves-effect  waves-light">
                <span className="s-caret"><i className="fa fa-angle-down"></i></span>
                <span className="s-icon"><i className="ti-bar-chart-alt"></i></span>
                <span className="s-text">Reports</span>
              </a>
              <ul style={ (window.location.pathname.startsWith('/reports') ? { display: 'block' } : {} ) }>
								<li className={'with-sub ' + (window.location.pathname === '/reports/endofday' ? 'active' : '')}><Link to="/reports/endofday">End of Day</Link></li>
                <li className={'with-sub ' + (window.location.pathname === '/reports/detailedorder' ? 'active' : '')}><Link to="/reports/detailedorder">Detailed Order</Link></li>
                <li className={'with-sub ' + (window.location.pathname === '/reports/timesheets' ? 'active' : '')}><Link to="/reports/timesheets">Timesheets</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/containers/sidebar.js